export default {
  // Main navigation
  home: 'Home',
  back: 'Back',
  next: 'Next',
  previous: 'Previous',
  start: 'Start',
  continue: 'Continue',
  finish: 'Finish',
  skip: 'Skip',
  cancel: 'Cancel',
  close: 'Close',
  save: 'Save',
  select: 'Pick',
  edit: 'Edit',
  delete: 'Delete',
  logout: 'Logout',
  settings: 'Settings',
  
  // Page titles
  overview: 'Overview',
  myWork: 'My Work',
  mySchool: 'My School',
  myLifestyle: 'My Lifestyle',
  myGoals: 'My Goals',
  myLifestylePlan: 'My Lifestyle Plan',
  results: 'Results',
  plan: 'Plan',
  
  // Button labels
  getStarted: 'Get Started',
  startOver: 'Start Over',
  viewResults: 'View Results',
  createPlan: 'Create Plan',
  loadPlan: 'Load Plan',
  newPlan: 'New Plan',
  previousProfiles: 'Previous Profiles',
  
  // Loading states
  loading: 'Loading...',
  loadingQuestions: 'Loading questions...',
  loadingPlan: 'Loading plan...',
  saving: 'Saving...',
  processing: 'Processing...',
  
  // Error messages
  errorOccurred: 'An error occurred',
  tryAgain: 'Please try again',
  contactSupport: 'Contact support if the problem persists',
  networkError: 'Network error',
  serverError: 'Server error',
  
  // Success messages
  savedSuccessfully: 'Saved successfully',
  planCreated: 'Plan created successfully',
  changesSaved: 'Changes saved',
  
  // Form labels
  email: 'Email',
  password: 'Password',
  confirmPassword: 'Confirm Password',
  firstName: 'First Name',
  lastName: 'Last Name',
  company: 'Company',
  
  // Validation messages
  required: 'This field is required',
  invalidEmail: 'Please enter a valid email address',
  passwordTooShort: 'Password must be at least 6 characters',
  passwordsDoNotMatch: 'Passwords do not match',
  
  // Help text
  help: 'Help',
  instructions: 'Instructions',
  tips: 'Tips',
  moreInfo: 'More Information',
  
  // Modal titles
  confirmAction: 'Confirm Action',
  warning: 'Warning',
  information: 'Information',
  success: 'Success',
  ok: 'OK',
  
  // Time and dates
  today: 'Today',
  yesterday: 'Yesterday',
  thisWeek: 'This Week',
  thisMonth: 'This Month',
  lastMonth: 'Last Month',
  
  // Progress indicators
  step: 'Step',
  of: 'of',
  progress: 'Progress',
  progressCompleted: 'Completed',
  remaining: 'Remaining',
  
  // Status messages
  notStarted: 'Not Started',
  inProgress: 'In Progress',
  statusCompleted: 'Completed',
  pending: 'Pending',
  active: 'Active',
  inactive: 'Inactive'
}; 